import { useTranslation } from "react-i18next";
import useCyrafaPaymentLabel from "./useCyrafaPaymentLabel";

function PaymentMethodCaption({ method }) {
  const { t } = useTranslation();
  const cyrafaPaymentLabel = useCyrafaPaymentLabel();

  if (method.gateway === "CYRAFA_PAY") {
    return (
      <span className="cyrafa-payment-caption mt-2">
        <img src="/img/payment-method/usdt-icon.png" alt="" aria-hidden="true" />
        <span dir="auto">{cyrafaPaymentLabel}</span>
      </span>
    );
  }

  return method.text ? (
    <small className="text-muted text-center mt-1">{t(method.text)}</small>
  ) : null;
}

export default PaymentMethodCaption;
